import { get } from 'lodash';
import { MAIN_PANEL } from '../constants/panel-types';

const getProperties = config => config.properties;
const getDeviceTypeProperties = (config, deviceType) => get(getProperties(config), [deviceType]);
export const getMainPanelProperties = (config, deviceType) =>
  get(getDeviceTypeProperties(config, deviceType), [MAIN_PANEL]);
